import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Trans } from 'lingui-react';
import { compact } from 'lodash';

import StatusSpan from 'elements/StatusSpan';

import { getAssetStatusText } from 'utils/asset';

import { CardElement, CardTable, CardTableRow } from 'elements/Card';

import messages from './messages';

function AssetStatus({ assetInfo }) {
  const pmStatus = assetInfo.get('pmStatus');

  return (
    <CardElement>
      <CardTable
        modifiers={['capitalize']}
        tdModifiers={['leftAlign']}
        thModifiers={['extraWide']}
      >
        <tbody>
          <CardTableRow>
            <th>
              <Trans id={messages.pmStatus} />
            </th>
            <td>
              <StatusSpan modifiers={compact(['bold', pmStatus, 'capitalize'])}>
                {getAssetStatusText('pmStatus', pmStatus, messages.pmStatus)}
              </StatusSpan>
            </td>
          </CardTableRow>
        </tbody>
      </CardTable>
    </CardElement>
  );
}

AssetStatus.propTypes = {
  assetInfo: ImmutablePropTypes.contains({
    pmStatus: PropTypes.string,
  }).isRequired,
};

export default AssetStatus;



// WEBPACK FOOTER //
// ./components/AssetDisplayElement/AssetStatus.js